// @flow

<template>
  <tr :class="[activeOrReplacedClass]" @click="navigateToDetails">
    <td class="engraved_id">{{ card.engravedId | engravedId }}</td>
    <td class="ascription">{{ card.ascription }}</td>
    <td class="ascription1">{{ card.ascription1 }}</td>
    <td class="ascription2">{{ card.ascription2 }}</td>
  </tr>
</template>
<script>

import type { CardSummary } from '../../types/card-summary'

export default {
  name: 'CardListItem',
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeOrReplacedClass: function (card: CardSummary) {
      return card.is_replaced ? 'card-replaced' : 'card-active'
    }
  },
  methods: {
    navigateToDetails: function () {
      this.$router.push(
        {
          name: 'card-details',
          params: {
            cardId: this.card.cardId
          }
        })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/cards/CardListItem.vue